/**
 * 회원가입·동의 모달의 약관 본문(기본값).
 * 공개 전문 페이지(/terms, /privacy)와 같은 원문(legalDocuments.ts)을 평문으로 변환해 사용합니다.
 * 관리자 화면(/admin/legal)에 등록된 현행 버전이 있으면 그 내용이 우선 표시됩니다.
 */
import { LEGAL_PRIVACY_MD, LEGAL_TERMS_MD } from './legalDocuments';

/** 마크다운 원문 → 모달 <pre> 표시용 평문 (제목 기호·굵게·표 구분선 제거) */
export function legalMarkdownToPlainText(md: string): string {
  return md
    .replace(/\r\n/g, '\n')
    .split('\n')
    .filter((line) => !/^\s*\|[\s:|-]+\|?\s*$/.test(line))
    .map((line) => {
      let l = line.replace(/^#{1,6}\s+/, '').replace(/\*\*([^*]+)\*\*/g, '$1');
      if (/^\s*\|/.test(l)) {
        l = l
          .trim()
          .replace(/^\|/, '')
          .replace(/\|\s*$/, '')
          .split('|')
          .map((c) => c.trim())
          .join(' / ');
        l = `- ${l}`;
      }
      return l;
    })
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export const CURRICULUM_PLANNER_TERMS_TITLE = '클래스 플래너 이용약관';

export const CURRICULUM_PLANNER_TERMS_BODY = `${legalMarkdownToPlainText(LEGAL_TERMS_MD)}

전문 페이지: /terms (환불 기준: /terms#refund)`;

export const CURRICULUM_PLANNER_PRIVACY_TITLE = '개인정보처리방침 (클래스 플래너)';

export const CURRICULUM_PLANNER_PRIVACY_BODY = `${legalMarkdownToPlainText(LEGAL_PRIVACY_MD)}

전문 페이지: /privacy`;
